import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-173fc240"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Meterstanden op het moment van oplevering.", -1))

import { deliveryStore } from '@/stores/delivery'

export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryMetersCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Meterstanden",
    bordered: false
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_a_row, { gutter: [32,16] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Water:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "m3",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.water,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.water) = $event)),
                        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Warmtemeter:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "GJ",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.heating,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.heating) = $event)),
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("T1:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "kWh",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.t1,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.t1) = $event)),
                        onBlur: _cache[5] || (_cache[5] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("T2:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "kWh",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.t2,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.t2) = $event)),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("T3:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "kWh",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.t3,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.t3) = $event)),
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, { class: "delivery-meter-row" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 8}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("T4:")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    xs: {span: 24},
                    sm: {span: 24},
                    md: {span: 24},
                    lg: {span: 16}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        type: "number",
                        suffix: "kWh",
                        disabled: _unref(deliveryStore)().deliveryClosed || _unref(deliveryStore)().loading.updating,
                        value: _unref(deliveryStore)().delivery.meters.t4,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(deliveryStore)().delivery.meters.t4) = $event)),
                        onBlur: _cache[11] || (_cache[11] = ($event: any) => (_unref(deliveryStore)().updateDelivery('meters', _unref(deliveryStore)().delivery.meters)))
                      }, null, 8, ["disabled", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})